import { getErrorBody } from './requestErrors';

export function coaValidationMessage(error: unknown, fallback: string): string {
  const body = getErrorBody(error);
  const message = typeof body === 'string' ? body
    : body && typeof body === 'object' && 'message' in body ? String(body.message) : '';
  const errorMessage = error instanceof Error ? error.message : '';
  return [message, errorMessage].find(value => /COA_(RESULT|NO_ELIGIBLE)/.test(value)) || fallback;
}
